const routes = {
  upload: '/upload',
  inspect: '/bekijken',
};

export default routes;
